import _implicitStylesheets from "./loginView.css";

import _implicitScopedStylesheets from "./loginView.scoped.css?scoped=true";

import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {t: api_text, h: api_element, gid: api_scoped_id, b: api_bind} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_element("div", {
    classMap: {
      "login-wrapper": true
    },
    key: 0
  }, [api_element("div", {
    classMap: {
      "login": true
    },
    key: 1
  }, [api_element("h2", {
    key: 2
  }, [api_text("Welcome, please log in to Zippi")]), api_element("div", {
    classMap: {
      "login-form": true
    },
    key: 3
  }, [api_element("label", {
    attrs: {
      "for": api_scoped_id("apiKey")
    },
    key: 4
  }, [api_text("API Key: ")]), api_element("input", {
    classMap: {
      "txt-input": true
    },
    attrs: {
      "type": "text",
      "id": api_scoped_id("apiKey"),
      "name": "apiKey"
    },
    props: {
      "value": $cmp.apiKey
    },
    key: 5,
    on: {
      "change": _m0 || ($ctx._m0 = api_bind($cmp.handleChange))
    }
  }, []), api_element("label", {
    attrs: {
      "for": api_scoped_id("sfUserName")
    },
    key: 6
  }, [api_text("Username: ")]), api_element("input", {
    classMap: {
      "txt-input": true
    },
    attrs: {
      "type": "text",
      "id": api_scoped_id("sfUserName"),
      "name": "username"
    },
    props: {
      "value": $cmp.username
    },
    key: 7,
    on: {
      "change": _m1 || ($ctx._m1 = api_bind($cmp.handleChange))
    }
  }, []), api_element("label", {
    attrs: {
      "for": api_scoped_id("sfPassword")
    },
    key: 8
  }, [api_text("Password: ")]), api_element("input", {
    classMap: {
      "txt-input": true
    },
    attrs: {
      "type": "password",
      "id": api_scoped_id("sfPassword"),
      "name": "password"
    },
    props: {
      "value": $cmp.password
    },
    key: 9,
    on: {
      "change": _m2 || ($ctx._m2 = api_bind($cmp.handleChange))
    }
  }, []), api_element("input", {
    classMap: {
      "slds-button--brand": true
    },
    attrs: {
      "type": "button"
    },
    props: {
      "value": "Log In"
    },
    key: 10,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.handleClick))
    }
  }, [])])])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "zpaper-loginView_loginView"
